// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { questionsWidgetStyles } from "@rpsc/App/Widgets/QuestionsWidget/QuestionsWidget";
import { color } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

questionsWidgetStyles.title = {
    variant: "h4",
    css: css`
        margin-bottom: 8px;
    `,
};
questionsWidgetStyles.content = {
    css: css`
        &,
        & > ${TypographyStyle} {
            font-size: 14px;
        }
    `,
};

questionsWidgetStyles.phone = {
    typographyProps: {
        size: 14,
        css: css`
            &&& {
                line-height: 17px;
            }
        `,
    },
};

questionsWidgetStyles.salesRepWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};

questionsWidgetStyles.salesRepName = {
    as: "p",
    size: 14,
    lineHeight: "22px",
};

questionsWidgetStyles.salesRepTitle = {
    as: "p",
    variant: "h6",
};

questionsWidgetStyles.separatorWrapper = {
    css: css`
        margin: 16px 0;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
